import { IApplicationState } from '../../types/redux';

export const selectCurrentPage = (state: IApplicationState): number => {
  return state.reviews.page;
};
